import React from 'react';
import DisaggMainContainer from '../../standalone/Disagg/DisaggMain/DisaggMainContainer';
import { connect } from 'react-redux';
import { setPageTitle } from '../../../helpers/helper';

class FAQsPageMain extends React.Component{

    componentDidMount(){
        setPageTitle("FAQ_PAGE.TITLE", this.props.translations.data, this.props.configs.data);
    }

    render(){
        return(
            <>
                <DisaggMainContainer/>
            </>
        )
    }
}

const mapStateToProps = state => {
    return {
        configs : state.configs,
        translations : state.translationsData
    }
}

export default connect(mapStateToProps)(FAQsPageMain)